(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-components"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-components')) {
  customElements.define('dp-components', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const eventOptions = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.input = this.querySelector('[data-search-input]');
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.category = 'all';
      this.input.disabled = false;
      this.filters.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => {
          this.category = button.dataset.filter;
          this.update();
        }, eventOptions);
      });
      this.input.addEventListener('input', () => this.update(), eventOptions);
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.category = 'all';
        this.input.value = '';
        this.update();
        this.input.focus();
      }, eventOptions);
      this.update();
    }
    update() {
      const words = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matches = (this.category === 'all' || card.dataset.category === this.category) && words.every(word => card.dataset.search.includes(word));
        card.hidden = !matches;
        if (matches) count++;
      });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      const status = this.querySelector('[data-count]');
      status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(count));
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-homepage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-surface-slideshow')) {
  customElements.define('dp-surface-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.current = 0;
      this.visible = false;
      this.sequence = 0;
      this.interval = Math.max(3000, Number(this.dataset.interval || 5) * 1000);
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.schedule();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index < 0) return;
        this.paused = true;
        this.show(index);
        this.schedule();
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.sequence++;
      this.events?.abort();
      this.observer?.disconnect();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.visible || document.hidden) return;
      this.timer = setTimeout(async () => {
        await this.show((this.current + 1) % this.slides.length);
        this.schedule();
      }, this.interval);
    }
    async show(index) {
      if (index === this.current || !this.slides[index]) return;
      const sequence = ++this.sequence;
      const image = this.slides[index].querySelector('img');
      try { if (!image.complete) await image.decode(); } catch { return; }
      if (sequence !== this.sequence || !this.isConnected || !image.naturalWidth) return;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
      this.current = index;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-range-catalogue"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-range-catalogue')) {
  customElements.define('dp-range-catalogue', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const eventOptions = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.input = this.querySelector('[data-search-input]');
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.category = 'all';
      this.input.disabled = false;
      this.filters.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => {
          this.category = button.dataset.filter;
          this.update();
        }, eventOptions);
      });
      this.input.addEventListener('input', () => this.update(), eventOptions);
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.category = 'all';
        this.input.value = '';
        this.update();
        this.input.focus();
      }, eventOptions);
      this.update();
    }
    update() {
      const words = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matches = (this.category === 'all' || card.dataset.category === this.category) && words.every(word => card.dataset.search.includes(word));
        card.hidden = !matches;
        if (matches) count++;
      });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === this.category)));
      const status = this.querySelector('[data-count]');
      status.textContent = status.dataset.countTemplate.replace('__COUNT__', String(count));
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-shop')) {
  customElements.define('dp-shop', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.cards.forEach((card, index) => card.dataset.order = index);
      this.priorityHandles = this.dataset.priorityHandles.split(',');
      this.input = this.querySelector('[data-search]');
      this.sort = this.querySelector('[data-sort]');
      this.filters = Array.from(this.querySelectorAll('button[data-category]'));
      this.category = 'all';
      this.input.disabled = false;
      this.sort.disabled = false;
      this.filters.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => { this.category = button.dataset.category; this.update(); }, options);
      });
      this.input.addEventListener('input', () => this.update(), options);
      this.sort.addEventListener('change', () => this.update(), options);
      this.querySelector('[data-browse-all]').addEventListener('click', () => { this.category = 'all'; this.input.value = ''; this.update(); }, options);
      this.querySelector('[data-reset]').addEventListener('click', () => { this.category = 'all'; this.input.value = ''; this.update(); this.input.focus(); }, options);
      this.refreshFilters(); this.update(); this.loadRemaining(this.controller.signal);
    }
    refreshFilters() {
      this.filters.forEach(button => button.hidden = button.dataset.category !== 'all' && !this.cards.some(card => card.dataset.category === button.dataset.category));
    }
    update() {
      const words = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matches = (this.category === 'all' || card.dataset.category === this.category) && words.every(word => card.dataset.search.includes(word));
        card.hidden = !matches; if (matches) count++;
      });
      const ordered = [...this.cards].sort((a, b) => {
        if (this.sort.value === 'price_asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (this.sort.value === 'price_desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (this.sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        const aPriority = this.priorityHandles.indexOf(a.dataset.productHandle);
        const bPriority = this.priorityHandles.indexOf(b.dataset.productHandle);
        const aRank = aPriority >= 0 ? aPriority : 100 + Number(a.dataset.order);
        const bRank = bPriority >= 0 ? bPriority : 100 + Number(b.dataset.order);
        return aRank - bRank;
      });
      const grid = this.querySelector('.dshop-product-grid');
      ordered.forEach(card => grid.append(card));
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      const status = this.querySelector('[data-count]');
      status.textContent = status.dataset.template.replace('__COUNT__', String(count));
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    async loadRemaining(signal) {
      const pageData = this.querySelector('[data-page-data]');
      let next = pageData?.dataset.nextUrl;
      if (!next || Number(pageData.dataset.currentPage) > 1) return;
      const note = this.querySelector('[data-page-note]');
      const fallback = note.textContent;
      note.textContent = note.dataset.loadingLabel;
      const visited = new Set();
      try {
        while (next) {
          const url = new URL(next, window.location.href);
          if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid catalogue page');
          visited.add(url.href); url.searchParams.set('section_id', pageData.dataset.sectionId);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Catalogue page unavailable');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('dp-shop');
          if (!page || !page.querySelector('[data-page-data]')) throw new Error('Catalogue section unavailable');
          if (signal.aborted || !this.isConnected) return;
          page.querySelectorAll('[data-card]').forEach(card => {
            if (!this.cards.some(existing => existing.dataset.productHandle === card.dataset.productHandle)) {
              card.dataset.order = this.cards.length; this.querySelector('.dshop-product-grid').append(card); this.cards.push(card);
            }
          });
          next = page.querySelector('[data-page-data]').dataset.nextUrl;
          this.refreshFilters(); this.update();
        }
        note.hidden = true; this.querySelector('[data-pagination]').hidden = true;
      } catch (error) { if (!signal.aborted) note.textContent = fallback; }
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-surfaces"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dp-surfaces')) {
  customElements.define('dp-surfaces', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.input = this.querySelector('[data-search]');
      this.brandSelect = this.querySelector('[data-brand-select]');
      this.filters = Array.from(this.querySelectorAll('button[data-type]'));
      this.type = 'all';
      this.input.disabled = false;
      this.brandSelect.disabled = false;
      this.filters.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => { this.type = button.dataset.type; this.update(); }, options);
      });
      this.input.addEventListener('input', () => this.update(), options);
      this.brandSelect.addEventListener('change', () => this.update(), options);
      this.addEventListener('click', event => {
        const brandLink = event.target.closest('[data-brand-link]');
        const allLink = event.target.closest('[data-show-all]');
        if (!brandLink && !allLink) return;
        this.brandSelect.value = brandLink ? brandLink.dataset.brandLink : 'all';
        this.type = 'all'; this.input.value = ''; this.update();
      }, options);
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.brandSelect.value = 'all'; this.type = 'all'; this.input.value = ''; this.update(); this.input.focus();
      }, options);
      this.refreshTypes();
      this.update();
      this.loadRemaining(this.controller.signal);
    }
    refreshTypes() {
      this.filters.forEach(button => {
        button.hidden = button.dataset.type !== 'all' && !this.cards.some(card => card.dataset.type === button.dataset.type);
      });
    }
    async loadRemaining(signal) {
      const pageData = this.querySelector('[data-page-data]');
      let next = pageData?.dataset.nextUrl;
      if (!next || Number(pageData.dataset.currentPage) > 1) return;
      const note = this.querySelector('[data-page-note]');
      const fallback = note.textContent;
      note.textContent = note.dataset.loadingLabel;
      const visited = new Set();
      try {
        while (next) {
          const url = new URL(next, window.location.href);
          if (url.origin !== window.location.origin || visited.has(url.href)) throw new Error('Invalid catalogue page');
          visited.add(url.href);
          url.searchParams.set('section_id', pageData.dataset.sectionId);
          const response = await fetch(url, { signal });
          if (!response.ok) throw new Error('Catalogue page unavailable');
          const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = documentPage.querySelector('dp-surfaces');
          if (!page || !page.querySelector('[data-page-data]')) throw new Error('Catalogue section unavailable');
          if (signal.aborted || !this.isConnected) return;
          page.querySelectorAll('[data-card]').forEach(card => {
            if (!this.cards.some(existing => existing.dataset.productHandle === card.dataset.productHandle)) {
              this.querySelector('.ds-grid').append(card);
              this.cards.push(card);
            }
          });
          page.querySelectorAll('[data-brand-link]').forEach(link => {
            if (!Array.from(this.querySelectorAll('[data-brand-link]')).some(existing => existing.dataset.brandLink === link.dataset.brandLink)) {
              this.querySelector('.ds-brands').append(link);
            }
          });
          page.querySelectorAll('[data-brand-select] option').forEach(option => {
            if (!Array.from(this.brandSelect.options).some(existing => existing.value === option.value)) this.brandSelect.append(option);
          });
          next = page.querySelector('[data-page-data]').dataset.nextUrl;
          this.refreshTypes(); this.update();
        }
        note.hidden = true;
        this.querySelector('[data-pagination]').hidden = true;
      } catch (error) {
        if (!signal.aborted) note.textContent = fallback;
      }
    }
    update() {
      const words = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const matches = (this.brandSelect.value === 'all' || card.dataset.brand === this.brandSelect.value) && (this.type === 'all' || card.dataset.type === this.type) && words.every(word => card.dataset.search.includes(word));
        card.hidden = !matches; if (matches) count++;
      });
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.type === this.type)));
      const status = this.querySelector('[data-count]');
      status.textContent = status.dataset.template.replace('__COUNT__', String(count));
      this.querySelector('[data-empty]').hidden = count !== 0;
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
